<div>
    <div class="wash-section-title">
        <img src="../../../../assets/icons/calendar-icon.svg" alt="calendar-icon" />
        Extras
        {{'EDIT_SERVICES.SERVICE_INFO.2' | translate}}
    </div>

    <div class="wash-content-box" *ngIf="SpecializedCenterWashProducts && SpecializedCenterWashProducts.length > 0">
        <div class="wash-title">
            {{ 'specialized_center_wash' | translate }}
        </div>
        <div class="wash-description">
            {{ 'specialized_center_wash_description' | translate }}
        </div>
        <div class="products-container">
            <div *ngFor="let product of SpecializedCenterWashProducts"
                [ngClass]="{'active-card': ProductSelected == product} " class="product-card">
                <img [src]="product.icon" alt="{{ product.titleId }}" />
                <div>
                    <div class="title-box">
                        {{ product.titleId }}
                        <app-toggle [isActive]="isToppingSelected(product)"
                            (isActiveChange)="onActiveProductChange($event, product)"></app-toggle>
                    </div>
                    <div class="description-box">
                        {{ product.descriptionId }}
                    </div>
                    <div class="price-text">
                        +{{ product.price }}{{ ServiceForm?.value[FORM_KEYS.AddressData][FORM_KEYS.ZoneId] |
                        CurrencyByZoneId }}
                    </div>
                </div>
            </div>

        </div>
    </div>
    <div class="wash-content-box" *ngIf="TunnelWashProductsProducts && TunnelWashProductsProducts.length > 0">
        <div class="wash-title">
            {{ 'tunnel_wash' | translate }}
        </div>
        <div class="wash-description">
            {{ 'tunnel_wash_description' | translate }}
        </div>

        <div class="products-container">
            <div *ngFor="let product of TunnelWashProductsProducts"
                [ngClass]="{'active-card': ProductSelected == product} " class="product-card">
                <img [src]="product.icon" alt="{{ product.titleId }}" />
                <div>
                    <div class="title-box">
                        {{ product.titleId }}
                        <app-toggle [isActive]="isToppingSelected(product)"
                            (isActiveChange)="onActiveProductChange($event, product)"></app-toggle>
                    </div>
                    <div class="description-box">
                        {{ product.descriptionId }}
                    </div>
                    <div class="price-text">
                        +{{ product.price }}{{ ServiceForm?.value[FORM_KEYS.AddressData][FORM_KEYS.ZoneId] |
                        CurrencyByZoneId }}
                    </div>
                </div>
            </div>
        </div>
    </div>




</div>